import { render, staticRenderFns } from "./Xchu.vue?vue&type=template&id=fe629102&scoped=true"
import script from "./Xchu.vue?vue&type=script&lang=js"
export * from "./Xchu.vue?vue&type=script&lang=js"
import style0 from "./Xchu.vue?vue&type=style&index=0&id=fe629102&prod&lang=css"
import style1 from "./Xchu.vue?vue&type=style&index=1&id=fe629102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe629102",
  null
  
)

export default component.exports